import { useTranslation } from 'react-i18next'
import React from 'react'
import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import useCodelist from 'features/declaration/codelist/api/useCodelist'
import FormCollapsibleColumn from 'components/p5/FormCollapsibleColumn'
import FormField from 'components/p5/FormField'
import FormSelect from 'components/p5/FormSelect'
import Input from 'components/p5/Input'
import useDeclarationFieldRequirements
  from 'features/declaration/form/components/useDeclarationFieldRequirements'

const scope = 'placeOfDelivery'

function PlaceOfDelivery() {
  const { t } = useTranslation()
  const [, countriesOptions] = useCodelist('COUNTRIES')

  const fieldRequirements = useDeclarationFieldRequirements<TransitOperationFormValues>('transitOperation', [
    'placeOfDelivery',
    'placeOfDelivery.country',
    'placeOfDelivery.location',
  ])

  return (
    <section className="py-3">
      <FormCollapsibleColumn
        columnId="declaration-loading-place"
        headingLabel={t('declaration.p5.placeOfDelivery')}
        fieldRule={fieldRequirements.placeOfDelivery}
      >
        <FormField
          labelKey="declaration.p5.nationality"
          fieldRule={fieldRequirements['placeOfDelivery.country']}
        >
          <FormSelect
            <TransitOperationFormValues>
            field={`${scope}.country`}
            labelKey="declaration.p5.nationality"
            options={countriesOptions}
            type="sync"
            fieldRule={fieldRequirements['placeOfDelivery.country']}
          />
        </FormField>
        <FormField
          labelKey="declaration.p5.placeOfDeliveryLocation"
          fieldRule={fieldRequirements['placeOfDelivery.location']}
        >
          <Input
            <TransitOperationFormValues>
            field={`${scope}.location`}
            labelKey="declaration.p5.placeOfDeliveryLocation"
            type="text"
            maxLength={35}
            placeholder={t('declaration.p5.placeOfDeliveryLocation')}
            fieldRule={fieldRequirements['placeOfDelivery.location']}
          />
        </FormField>
      </FormCollapsibleColumn>
    </section>
  )
}

export default PlaceOfDelivery
